module.exports = __webpack_public_path__ + "static/card-jobs-2-a56e2210a3fa21d1ef25b8c61a47f1de.jpg";